import React from 'react'

import { ParagraphInactiveProps } from './paragraphInactive.types'
import * as S from './../../fieldsInactive.styles'

export const ParagraphInactive = ({ item, ...props }: ParagraphInactiveProps) => {
    return (
        <S.FieldInactiveWrapper {...props}>
            <S.Header>
                <S.Title>{item.value}</S.Title>

                {item.required && <S.Required>*Required</S.Required>}
            </S.Header>

            <S.TextField>Long answer text</S.TextField>
        </S.FieldInactiveWrapper>
    )
}
